import { render, staticRenderFns } from "./PersonRulesIndex.vue?vue&type=template&id=646d0d25&scoped=true&"
import script from "./PersonRulesIndex.vue?vue&type=script&lang=js&"
export * from "./PersonRulesIndex.vue?vue&type=script&lang=js&"
import style0 from "./PersonRulesIndex.vue?vue&type=style&index=0&id=646d0d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d0d25",
  null
  
)

export default component.exports